<!-- A page on its own: no app bar, drawer or footer. Used for the legal pages
     on terms.tapleagues.com (see middleware/termsHost.global.js). -->
<template>
  <v-app class="bg-light">
    <v-main class="bg-light">
      <nuxt-page />
    </v-main>
  </v-app>
</template>
